export default __webpack_public_path__ + "static/officework-tile-27ad4334b143e7b475e18dada9a7be44.webp";